import React, { useEffect, useState, useReducer, useRef, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  useLazyGetServiceSummaryDataQuery,
  useLazyGetServiceModulesDataQuery,
  useGetTopLeastServicesDataQuery,
} from "../slices/getqueries/getqueriesApi";
import { useDispatch, useSelector } from "react-redux";
import NewBarChartComponent from "../components/NewBarChartComponent.jsx";
// import Gravitonvideo from '../assets/SampleVideo_1280x720_1mb.mp4'
import HeaderBanner from '../assets/Banner.png';
// import VideoBanner from '../assets/Video Banner.png'
import Scan from '../assets/Scan.svg'
import Rupee from '../assets/Rupee.svg'
import Speed from '../assets/Speed.svg'
import Phone from '../assets/Phone.svg'
import Bank from '../assets/Bank.svg'
import ArrowUp from '../assets/ArrowUp.svg'
import ArrowDown from '../assets/ArrowDown.svg'
import NewDateandTimePicker from "../components/NewDateandTimePicker";
import Pagination from '@mui/material/Pagination';
import {format} from 'date-fns';
import Skeleton from '@mui/material/Skeleton';
import {formatINRCurrencyWithDecimals,formatINRCurrencyNoDecimals} from '../numberFormatter'
function NewHomeScreen() {
    
  const videoRef = useRef(null);
  const { userInfo } = useSelector((state) => state.auth);
  const { clientId } = userInfo;
  const navigate = useNavigate();
  const [selectedCard, setSelectedCard] = useState(null);
  const [showVideo, setShowVideo] = useState("");
  const [duration, setDuration] = useState("");
  const location = useLocation();  
 
  const handlePlayClick = () => {
    setShowVideo(true);
    setTimeout(() => {
      videoRef.current?.play();
    }, 0);
  };

  const handleLoadedMetadata = () => {
    const video = videoRef.current;
    if (video) {
      const minutes = Math.floor(video.duration / 60);
      const seconds = Math.floor(video.duration % 60)
        .toString()
        .padStart(2, "0");
      setDuration(`${minutes}:${seconds}`);
    }
   };

  const dispatchRedux = useDispatch();
  const today = new Date();
  const defaultRange = [today, today];
  const [dateRange, setDataRange] = useState(defaultRange);

const fromDate = format(dateRange[0], 'yyyy-MM-dd');
const toDate = format(dateRange[1], 'yyyy-MM-dd');

const [triggerSummary, { data: groupdata, isLoading: isSummaryLoading, isSuccess: isSummarySuccess, error: summaryError }] =
  useLazyGetServiceSummaryDataQuery();

const [triggerDetails, { data: serviceTableData, isLoading: isDetailsLoading, isError: isDetailsError, error: detailsError }] =
useLazyGetServiceModulesDataQuery();

const {
  data: topLeastData,
  isLoading: isTopLeastLoading,
  isSuccess: isTopLeastSuccess,
  error: topLeastError
} = useGetTopLeastServicesDataQuery({ clientname: clientId, fromDate, toDate }, { refetchOnMountOrArgChange: true });

const serviceIcons = {
  "KYC": <img src={Scan} alt="KYC" className="w-8 h-8 object-contain" />,
  "Payments": <img src={Rupee} alt="Payments" className="w-8 h-8 object-contain" />,
  "Credit Bureau": <img src={Speed} alt="Credit Bureau" className="w-8 h-8 object-contain" />,
  "Mobile Utilities": <img src={Phone} alt="Mobile Utilities" className="w-8 h-8 object-contain" />,
  "Banking Utilities": <img src={Bank} alt="Banking Utilities" className="w-8 h-8 object-contain" />,
};


const cardData = useMemo(() => {
  if (!groupdata || !groupdata.serviceGroupData) return [];

  return Object.entries(groupdata.serviceGroupData).map(([title, data]) => ({
    title,
    count: data.totalUsage,
    amount: `₹${parseFloat(data.totalAmount || 0).toFixed(2)}`,
    icon: serviceIcons[title] || null,
    groupId: data.groupId,
  }));
}, [groupdata]);
  
  const topServices = useMemo(() => {
    const safeData = Array.isArray(topLeastData) ? topLeastData[0] : topLeastData;
    if (!safeData?.top5Services) return [];
    return safeData.top5Services.map(service => ({
      name: service.modulename,
      usage: service.successCount.toLocaleString(),
      amount: `₹${parseFloat(service.totalCharge).toFixed(2)}`
    }));
  }, [topLeastData]);
  
  const leastServices = useMemo(() => {
    const safeData = Array.isArray(topLeastData) ? topLeastData[0] : topLeastData;
    if (!safeData?.least5Services) return [];
    return safeData.least5Services.map(service => ({
      name: service.modulename,
      usage: service.successCount.toLocaleString(),
      amount: `₹${parseFloat(service.totalCharge).toFixed(2)}`
    }));
  }, [topLeastData]);

const tableData = useMemo(() => {
  if (!serviceTableData || !Array.isArray(serviceTableData)) return [];

  return serviceTableData.map((item) => ({
    ...item,
    charge: `₹${parseFloat(item.charge || 0).toFixed(2)}`,
    usage: `₹${parseFloat(item.usage || 0).toFixed(2)}`,
    remaining: `₹${parseFloat(item.remaining || 0).toFixed(2)}`,
  }));
}, [serviceTableData]);
 
const [page, setPage] = useState(1);
const entriesPerPage = 2;

const currentData = tableData[selectedCard] || [];
const totalPages = Math.ceil((currentData?.length || 0) / entriesPerPage);


const paginatedData = useMemo(() => {
  if (!serviceTableData) return [];
  const start = (page - 1) * entriesPerPage;
  return serviceTableData.slice(start, start + entriesPerPage);
}, [serviceTableData, page]);


const handlePageChange = (event, value) => {
  setPage(value);
};


const handleDateRangeChange = (value) => {
  if (value && value.length === 2) {
    const [startDate, endDate] = value;
    localStorage.setItem("dashboardFromDate", format(startDate, 'yyyy-MM-dd'));
    localStorage.setItem("dashboardToDate", format(endDate, 'yyyy-MM-dd'));
    setDataRange(value);
  } else {
    const today = new Date();
    localStorage.setItem("dashboardFromDate", format(today, 'yyyy-MM-dd'));
    localStorage.setItem("dashboardToDate", format(today, 'yyyy-MM-dd'));
    setDataRange([today, today]);
    console.log('By Default Today Date selected');
  }
};
const fetchDashboardData = async () => {
  try {
    const res = await triggerSummary({ clientname: clientId, fromDate, toDate }).unwrap();

    if (!selectedCard && res?.serviceGroupData?.length > 0) {
      const defaultGroupId = res.serviceGroupData[0].groupId;
      setSelectedCard(defaultGroupId);
      triggerDetails({ clientname: clientId, groupId: defaultGroupId, fromDate, toDate });
    }

  } catch (err) {
    console.error("Error fetching dashboard data", err);
  }
};


useEffect(() => {
  const fromStorage = localStorage.getItem("dashboardFromDate");
  const toStorage = localStorage.getItem("dashboardToDate");

  if (fromStorage && toStorage) {
    const fromDate = new Date(fromStorage);
    const toDate = new Date(toStorage);
    setDataRange([fromDate, toDate]);
  } else {
    const today = new Date();
    setDataRange([today, today]);
  }
}, []);

useEffect(() => {
  const savedCard = JSON.parse(localStorage.getItem("selected_card"));
  if (savedCard && savedCard.id) {
    setSelectedCard(savedCard.id);
  }
}, []);

useEffect(() => {
  fetchDashboardData();
}, [fromDate, toDate]);


useEffect(() => {
  if (selectedCard && isSummarySuccess) {
    triggerDetails({ clientname: clientId, groupId: selectedCard, fromDate, toDate });
  }
}, [selectedCard, fromDate, toDate, isSummarySuccess]);

useEffect(() => {
  if (
    isSummarySuccess &&
    groupdata &&
    groupdata.serviceGroupData &&
    Object.keys(groupdata.serviceGroupData).length > 0 &&
    selectedCard === null
  ) {
    const firstGroupKey = Object.keys(groupdata.serviceGroupData)[0];
    const groupID = groupdata.serviceGroupData[firstGroupKey].groupId;

    console.log("Group ID:", groupID);
    setSelectedCard(groupID);
  }
}, [isSummarySuccess, groupdata, selectedCard]);


const handleNavigateSerivceData = (moduleid,modulename) => {
  navigate(`/servicedetails?key=${encodeURIComponent(moduleid)}&name=${encodeURIComponent(modulename)}`,{state: { showToast: true }});
};

  return (
       <>
<div>

<div className="w-full ">
      <div className="relative sm:flex sm:justify-between sm:items-center mb-4 sm:min-h-0 min-h-[120px]">
  <h2 className="text-[20px] font-[600] text-[#212121] text-center sm:text-left mb-5 sm:mb-0">
    Welcome to Graviton Services
  </h2>
  <div className="absolute right-4 bottom-2 sm:static sm:right-auto sm:bottom-auto flex flex-col items-end w-[fit-content] max-w-[260px]">
    <NewDateandTimePicker onDateRangeChange={handleDateRangeChange} value={dateRange} />
    <p className="text-[12px] text-[#204887] pl-[10px] mt-1 break-words">
      Updated records may require up to 2 hours to fully propagate and display.
    </p>
  </div>
</div>
      <div className="text-white rounded-[12px] p-6 flex flex-col md:flex-row gap-6 shadow-md relative overflow-hidden"   
      style={{
    backgroundImage: `url(${HeaderBanner})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}>
        {/* Left Thumbnail */}
        {/* <div className="flex-shrink-0 relative w-[150px] h-[100px] bg-gradient-to-r from-[#ECF4FF] to-[#9BC4FD] rounded-[12px] overflow-hidden">
          
          {!showVideo && (
            <>
              <img
                src={VideoBanner} 
                alt="Graviton Thumbnail"
                className="w-full h-full object-cover"
              />
              
              <div className="absolute top-8 left-2 right-1 px-4 z-10">
                <span className="text-[14px] font-[500] text-[#212121] block">
                  Graviton Services
                </span>
                <span className="text-[7px] font-[400] text-[#212121] block">
                  How to use the Graviton services
                </span>
              </div>

            
              <div className="absolute inset-0 flex items-center justify-center z-10">
                <button
                  onClick={handlePlayClick}
                  className="w-10 h-10 bg-[#204887] rounded-full shadow flex items-center justify-center text-[#ffffff] font-bold text-lg"
                >
                  ▶
                </button>
              </div>

              
              {duration && (
                <div className="absolute bottom-1 right-1 bg-[#ffffff] text-[#212121] text-xs px-2 py-0.5 rounded z-10">
                  {duration}
                </div>
              )}
            </>
          )}

          
          {showVideo && (
            <video
              ref={videoRef}
              onLoadedMetadata={handleLoadedMetadata}
              src={Gravitonvideo} // Replace with your video path
              className="w-full h-full object-cover"
              controls
            />
          )}
        </div> */}
        <div className="flex-1">
          <h3 className="text-[24px] font-[700] mb-1">
            Kickstart with Graviton Services
          </h3>
          <p className="text-[14px] font-[500] text-gray-200 mb-3">
            Take a quick look at this video to discover the key features of
            Graviton Services for managing your business.
          </p>
          {/* <div className="flex gap-2">
            <button className="px-3 py-1 bg-white text-[#2C2E83] rounded-full text-sm font-medium shadow hover:bg-gray-100 transition">
              Hindi
            </button>
            <button className="px-3 py-1 bg-white text-[#2C2E83] rounded-full text-sm font-medium shadow hover:bg-gray-100 transition">
              English
            </button>
          </div> */}
        </div>
      </div>
    </div>

<div className="w-full mt-6">
      <div
        className="border-[#204887] rounded-[12px] px-6 py-4 bg-[#ffffff] relative"
        style={{
          borderWidth: '2px',
          borderStyle: 'dashed',
          borderColor: '#204887',
        }}
      >
        <div className="lg:hidden w-full flex justify-end mb-4">
          <button
            className="px-4 py-2 bg-[#204887] hover:bg-[#183462] text-white text-[12px] rounded-full transition font-[600] shadow"
            onClick={() => navigate('/viewtransactions')}
          >
            View Transactions
          </button>
        </div>

        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6 lg:gap-[50px]">
          <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-7 items-end w-full lg:w-[70%]">
            {isSummaryLoading ? (
              Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="flex flex-col gap-2">
                  <Skeleton animation="wave" width="80%" height={20} />
                  <Skeleton animation="wave" width="60%" height={30} />
                </div>
              ))
            ) : (
              <>
                <div className="flex flex-row justify-between md:flex md:flex-col text-left">
                  <p className="text-[14px] text-[#212121] font-[400] sm:mt-2">Total Services</p>
                  <p className="text-[20px] text-[#212121] font-[700]">
                    {groupdata?.totalServices ?? "0"}
                  </p>
                </div>
                <div className="flex flex-row justify-between md:flex md:flex-col text-left">
                  <p className="text-[14px] text-[#212121] font-[400] sm:mt-2">Total Usage Count</p>
                  <p className="text-[20px] text-[#212121] font-[700]">
                    {formatINRCurrencyNoDecimals(groupdata?.totalUsageCount ?? "0")}
                  </p>
                </div>
                <div className="flex flex-row justify-between md:flex md:flex-col text-left">
                  <p className="text-[14px] text-[#212121] font-[400] sm:mt-2">Total Usage Amount</p>
                  <p className="text-[20px] text-[#212121] font-[700] break-words">
                    {formatINRCurrencyWithDecimals(groupdata?.totalUsageAmount ?? "0")}
                  </p>
                </div>
                <div className="flex flex-row justify-between md:flex md:flex-col text-left">
                  <p className="text-[14px] text-[#212121] font-[400] sm:mt-2">Total Remaining Balance</p>
                  <p className="text-[20px] text-[#188A42] font-[700] break-words">
                    {formatINRCurrencyWithDecimals(groupdata?.totalRemainingBalance ?? 0)}
                  </p>
                </div>
              </>
            )}
          </div>
          <div className="hidden lg:flex lg:w-auto justify-start">
            <span
              className="p-4 bg-[#204887] hover:bg-[#183462] text-white text-[12px] rounded-full transition font-[600] shadow whitespace-nowrap hover:cursor-pointer"
              onClick={() => navigate('/viewtransactions',{state: { showToast: true }}) }
            >
              View Transactions
            </span>
          </div>
        </div>
      </div>
</div>

<div className="w-full mt-6">
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mt-6">
          {isSummaryLoading ? (
            <>
            {[...Array(5)].map((_, index) => (
              <div key={index} className="rounded-[12px] p-6 shadow-sm bg-white flex flex-col gap-4 w-full">
                <div className="flex items-center justify-between">
                  <Skeleton variant="text" width={100} height={24} />
                  <Skeleton variant="circular" width={40} height={40} />
                </div>
                <Skeleton variant="text" width="60%" height={30} />
                <Skeleton variant="text" width="40%" height={30} />
              </div>
            ))}
          </>
          ) : summaryError ? (
            <div className="bg-white p-4 rounded-[12px] shadow w-full col-span-full">
            <div className="text-gray- text-center text-[15px] py-10">No Data Found</div>
            </div>
          ) : (
            cardData.map((item, idx) => (
              <div
                key={idx}
                className={`rounded-[12px] p-6 shadow-sm hover:cursor-pointer flex flex-col gap-4 relative hover:shadow-md transition-all ${
                  selectedCard === item.groupId
                    ? "bg-[#204887] text-white"
                    : "bg-white text-[#212121]"
                }`}
                onClick={() => {
                  setSelectedCard(item.groupId);
                  localStorage.setItem("selected_card", JSON.stringify({
                    id: item.groupId,
                    modulename: item.modulename,
                  }))
                  setPage(1);
                }}
              >
                <div className="flex items-center justify-between">
                  <p className="text-[14px] font-[500]">{item.title}</p>
                  <div className="p-2 rounded-[8px] bg-[#E5EFFF] flex items-center justify-center text-[16px]">
                    {item.icon}
                  </div>
                </div>
                <div className="flex flex-col items-start gap-1">
                  <p className="text-[16px] font-[600]">{formatINRCurrencyNoDecimals(item.count)}</p>
                  <p className="text-[20px] font-[600]">{formatINRCurrencyWithDecimals(item.amount)}</p>
                </div>
              </div>
            ))
          )}
        </div>
        {selectedCard && (
    <div className="bg-white rounded-[15px] shadow p-4 overflow-auto w-full mt-4">
      {isDetailsLoading ? (
        <div className="bg-white p-4 rounded-[12px] shadow w-full">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="flex gap-4 mb-4">
            <Skeleton variant="text" width="15%" height={20} />
            <Skeleton variant="text" width="15%" height={20} />
            <Skeleton variant="text" width="15%" height={20} />
            <Skeleton variant="text" width="15%" height={20} />
            <Skeleton variant="text" width="15%" height={20} />
            <Skeleton variant="text" width="15%" height={20} />
            <Skeleton variant="rectangular" width={100} height={36} />
          </div>
        ))}
      </div>
      ) : !serviceTableData || serviceTableData.length === 0 ? (
        <div className="text-gray-600 text-center text-[15px] py-10">No Data Found</div>
      ) : (
        <>
          <table className="w-full min-w-[800px] text-[14px] rounded-[10px]">
            <thead className="bg-[#E5EFFF] text-[#204887]">
              <tr className="text-center font-semibold">
                <th className="customized-table-header">Services</th>
                <th className="customized-table-header">Service Charge Amount</th>
                <th className="customized-table-header">Success Count</th>
                <th className="customized-table-header">Failed Count</th>
                <th className="customized-table-header">Usage Amount</th>
                <th className="customized-table-header">Remaining Amount</th>
                <th className="customized-table-header">Action</th>
              </tr>
            </thead>
            <tbody>
              {serviceTableData.map((tx, index) => (
                <tr key={index}>
                  <td className="customized-table-value break-words">{tx.modulename}</td>
                  <td className="customized-table-value">{formatINRCurrencyWithDecimals(tx.chargepercall)}</td>
                  <td className="customized-table-value">{formatINRCurrencyNoDecimals(tx.successCount)}</td>
                  <td className="customized-table-value">{formatINRCurrencyNoDecimals(tx.failureCount)}</td>
                  <td className="customized-table-value">{formatINRCurrencyWithDecimals(tx.totalCharge)}</td>
                  <td className="customized-table-value">{formatINRCurrencyWithDecimals(tx.creditleft)}</td>
                  <td className="customized-table-value">
                    <button
                      className="px-5 py-3 bg-[#204887] text-white rounded-[20px] hover:bg-[#183462] text-[12px]"
                      onClick={() => handleNavigateSerivceData(tx.moduleid,tx.modulename)}
                    >
                      View Details
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {totalPages > 1 && (
            <div className="flex justify-center mt-4">
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                showFirstButton
                showLastButton
                siblingCount={1}
                boundaryCount={1}
                color="primary"
                size="medium"
                sx={{
                  '& li': { border: 'none', boxShadow: 'none', margin: 0, padding: 0 },
                  '& .MuiPaginationItem-root': { fontSize: '1.2rem', fontWeight: 'bold' },
                }}
              />
            </div>
          )}
        </>
      )}
    </div>
  )}
      </div>

<div className="grid grid-cols-1 lg:grid-cols-2 my-10 gap-6">
  <div className="bg-white rounded-xl p-6 shadow w-full">
      <NewBarChartComponent serviceGroupData={groupdata?.serviceGroupData} />
  </div>
  <div className="bg-white p-6 rounded-xl shadow-md w-full">
    <div className="flex  justify-between mb-5 gap-4">
      <div className="flex flex-col md:flex-row  items-start md:items-center gap-2">
        <h3 className="font-[600] text-[18px] ">
          Top 5 Services
          
        </h3>
        <img
            src={ArrowUp}
            alt="Upward Arrow"
            className="w-8 h-8 inline-block"
          />
      </div>

      <div className="flex flex-col-reverse md:flex-row  items-end md:items-center gap-2">
        
        <img
          src={ArrowDown}
          alt="Downward Arrow"
          className="w-8 h-8 inline-block"
        />

        <h3 className="font-[600] text-[18px] text-end md:text-start">
        Least 5 Services
          
        </h3>
      </div>
    </div>
    <div className="w-full">
  {isTopLeastLoading ? (
    [...Array(5)].map((_, index) => (
      <div
        key={index}
        className="flex justify-between items-center border-b pb-2 mb-2 last:border-b-0 last:pb-0"
      >
        <div className="w-full">
          <Skeleton variant="text" width={100} height={20} className="mb-2" />
          <div className="grid sm:grid-cols-1 md:grid-cols-2 sm:gap-[10px] md:gap-[50px] md:w-[200px]">
            <Skeleton variant="text" width={60} height={20} />
            <Skeleton variant="text" width={60} height={20} />
          </div>
        </div>
        <div className="text-right flex items-center gap-4">
          <div>
            <Skeleton variant="text" width={100} height={20} className="mb-2" />
            <div className="grid sm:grid-cols-1 md:grid-cols-2 sm:gap-[10px] md:gap-[50px] md:w-[200px]">
              <Skeleton variant="text" width={60} height={20} />
              <Skeleton variant="text" width={60} height={20} />
            </div>
          </div>
        </div>
      </div>
    ))
  ): (topServices.length === 0 && leastServices.length === 0) ? (
    <div className="text-center text-gray-500 text-[16px] font-[500] py-[100px]">
      No Data Found
    </div>
  ) : (
    topServices.map((item, index) => (
      <div
        key={index}
        className="flex justify-between items-center border-b pb-2 mb-2 last:border-b-0 last:pb-0"
      >
        <div>
          <p className="text-[14px] text-gray-700 font-[500]">{item.name}</p>
          <div className="grid sm:grid-cols-1 md:grid-cols-2 sm:gap-[10px] md:gap-[50px] md:w-[200px] break-words">
            <p className="text-[16px] font-[700]">{formatINRCurrencyNoDecimals(item.usage)}</p>
            <div className="flex items-start">
              <p className="text-green-600 text-[16px] font-[700]">
                {formatINRCurrencyWithDecimals(item.amount)}
              </p>
            </div>
          </div>
        </div>
        <div className="text-right flex items-center gap-4">
          <div>
            <p className="text-[14px] text-gray-700 font-[500]">
              {leastServices[index]?.name || '-'}
              
            </p>
            <div className="grid sm:grid-cols-1 md:grid-cols-2 sm:gap-[10px] md:gap-[50px] md:w-[230px] break-words">
              <p className="text-red-600 text-[16px] font-[700]">
                {formatINRCurrencyWithDecimals(leastServices[index]?.amount)}
              </p>
              <p className="text-[16px] font-[700]">
                {formatINRCurrencyNoDecimals(leastServices[index]?.usage)}
              </p>
            </div>
          </div>
        </div>
      </div>
    ))
  )}
</div>
  </div>
    </div>
</div>
    </>
  )
}

export default NewHomeScreen
